<template>
  <div class="loading-container bg-slate-200 dark:bg-primary">
    <div class="loading-bar" :style="{ width: loadingWidth + '%' }" v-if="isLoading"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      loadingWidth: 0,
      interval: null,
    };
  },
  methods: {
    startLoading() {
      this.isLoading = true;
      this.loadingWidth = 0;
      this.interval = setInterval(() => {
        this.loadingWidth += 10;
        if (this.loadingWidth >= 100) {
          clearInterval(this.interval);
        }
      }, 100);
    },
    stopLoading() {
      clearInterval(this.interval);
      this.loadingWidth = 100;
      setTimeout(() => {
        this.isLoading = false;
        this.loadingWidth = 0;
      }, 500);
    },
  },
};
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 999;
}

.loading-bar {
  height: 100%;
  background-color: #3d65a2;
  transition: width 0.1s;
}
</style>
